export const RELAY_API_CONTENTFUL = "contentful";
